import type { PaigeClient } from '@paige/api-client';
import type { FileStory, RecentFiles, RecentFilesQuery } from './types';
import { unwrap } from './http';

/** The Document timeline (`/admin/timeline`): what arrived lately, and the story of one file for any id. */
export function timelineApi(client: PaigeClient) {
  return {
    async listRecentFiles(q: RecentFilesQuery): Promise<RecentFiles> {
      const query = {
        ...(q.text ? { q: q.text } : {}),
        ...(q.from ? { from: q.from } : {}),
        ...(q.to ? { to: q.to } : {}),
        ...(q.company ? { company: q.company } : {}),
        ...(q.before ? { before: q.before } : {}),
      };
      const r = await client.GET('/admin/timeline/recent', { params: { query } });
      return unwrap(r) as RecentFiles;
    },
    /** With `raw`, every ledger event rides along (engineering's expandable detail). */
    async findTimeline(q: string, raw = false): Promise<FileStory> {
      const query = raw ? { q, raw: true } : { q };
      const r = await client.GET('/admin/timeline', { params: { query } });
      return unwrap(r) as FileStory;
    },
  };
}

export type TimelineApi = ReturnType<typeof timelineApi>;
